import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "fill"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["fill"]

import { COLOR_SET } from '@/styles/variables'


export default /*#__PURE__*/_defineComponent({
  name: 'ExclamationMark',
  props: {
    color: null,
    size: null,
    fillColor: null,
    textColor: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 24,
    height: __props.size || 24,
    viewBox: "0 0 24 24",
    fill: __props.fillColor ? __props.fillColor : 'none',
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      transform: "rotate(-180 12 12)",
      stroke: __props.fillColor ? __props.fillColor : __props.color || _unref(COLOR_SET).red01,
      "stroke-width": "2"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M10.8189 18.6719L13.1549 18.6719L13.1549 16.3999L10.8189 16.3999L10.8189 18.6719ZM10.8349 5.99987L10.8349 14.9599L13.1709 14.9599L13.1709 5.99987L10.8349 5.99987Z",
      fill: __props.textColor ? __props.textColor : __props.color || _unref(COLOR_SET).red01
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})